export const propertyOptions = [
    {
        label: "Строка",
        value: "STRING"
    },
    {
        label: "Дата",
        value: "DATE"
    },
    {
        label: "Дата и время",
        value: "DATETIME"
    },
    {
        label: "Число",
        value: "NUMBER"
    }
]